import {Number, Schema, nonNegative} from 'effect/Schema';

export const NonNegative = Number.pipe(nonNegative()) as unknown as Schema<NonNegative>;
export type NonNegative = import('../src/NonNegative').NonNegative;
